import qs from 'qs';

import { store } from 'store/store';
import { API_URL } from 'utils';

export const logoutService = async () => {
  const { token } = store.getState().auth.data;
  const params = { token };

  const response = await fetch(`${API_URL}/sso/invalidate?${qs.stringify(params)}`, {
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${token}`,
    },
  });

  return { response };
};
